import { AsyncPipe, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, computed, inject, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DotCMSBlockEditorRendererComponent } from '@dotcms/angular';
import { Observable, combineLatest, map } from 'rxjs';

import { whenTruthy } from 'ish-core/utils/operators';

import { DYNAMIC_COMPONENTS } from '../../../configurations/dynamic-components';
import { DotCmsUveFacade } from '../../../facades/dot-cms-uve.facade';
import { BlogContentlet } from '../../../models/dot-cms-uve-contentlet.model';
import { DotCmsCodecEncodePipe } from '../../../pipes/dot-cms-codec-encode.pipe';
import { DotCmsBlogAuthorComponent } from '../dot-cms-uve-blog-author/dot-cms-uve-blog-author.component';
import { DotCmsBlogCommentsComponent } from '../dot-cms-uve-blog-comments/dot-cms-uve-blog-comments.component';

@Component({
  selector: 'custom-dot-cms-blog-page',

  templateUrl: './dot-cms-uve-blog-detail-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './dot-cms-uve-blog-detail-page.component.scss',
  imports: [
    AsyncPipe,
    DotCmsBlogAuthorComponent,
    DotCmsBlogCommentsComponent,
    RouterModule,
    DatePipe,
    DotCmsCodecEncodePipe,
    DotCMSBlockEditorRendererComponent,
  ],
})
export class DotCmsBlogPageComponent implements OnInit {
  post = input.required<BlogContentlet>();
  dotCmsUveFacade = inject(DotCmsUveFacade);
  previousUrl$: Observable<string>;

  postContent = computed(() => this.post().blogContent?.blogContent);

  customRenderers = DYNAMIC_COMPONENTS;

  buildImageSrc(): Observable<string> {
    return combineLatest([this.dotCmsUveFacade.getDotCmsHost$.pipe(whenTruthy())]).pipe(
      whenTruthy(),
      map(([host]) => `${host + this.post()?.imageBlog?.idPath}`)
    );
  }

  ngOnInit() {
    this.previousUrl$ = this.dotCmsUveFacade.getPreviousUrl();
  }

  getTags(tagString: string): string[] {
    if (tagString) {
      return tagString.split(',');
    }
    return [];
  }
}
